import { HolidayExceptionDate } from "@lib/types";
import { HolidayExceptionDateDto } from "../dtos/holidayExceptionDateDto";

/** Holiday exception date mapper. */
class HolidayExceptionDateMapper {

    /**
     * Maps model to dto.
     * @param model Model.
     */
    public toDto(model: HolidayExceptionDate): HolidayExceptionDateDto {
        return {
            date: model.date,
            isWeekend: model.isHoliday,
        };
    }

    /**
     * Maps dto to model.
     * @param dto Dto.
     */
    public fromDto(dto: HolidayExceptionDateDto): HolidayExceptionDate {
        return {
            date: dto.date,
            isHoliday: dto.isWeekend,
        };
    }
}

/** Holiday exception date mapper. */
export const holidayExceptionDateMapper = new HolidayExceptionDateMapper();
